import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IServerLogFileContentVm } from '../server-log-file-info-vm.model';

@Injectable({ providedIn: 'root' })
export class AdminServerLogFileService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/AdminServerLogFile`;
  }

  /**
   * Pobiera cały plik loga z raportowaniem postępu (pliki mogą mieć wiele MB,
   * więc UI pokazuje pasek postępu pobierania zanim zacznie analizę).
   */
  getWithProgress(fileName: string, source: string = 'server'): Observable<HttpEvent<IServerLogFileContentVm>> {
    const headers = this.createHeaders();
    const params = new HttpParams().set('fileName', fileName).set('source', source);
    const request = new HttpRequest('GET', this.baseUrl, {
      headers,
      params,
      reportProgress: true,
      responseType: 'json',
    });
    return this.http.request<IServerLogFileContentVm>(request);
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
